function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullscreenExit = function SvgFullscreenExit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.417 12.583H5.042a.526.526 0 0 1-.542-.537q0-.23.156-.387a.52.52 0 0 1 .386-.159H7.83q.285 0 .477.193a.65.65 0 0 1 .193.477v2.788a.526.526 0 0 1-.538.542.53.53 0 0 1-.387-.156.52.52 0 0 1-.158-.386zm5.166 0v2.375a.526.526 0 0 1-.537.542.53.53 0 0 1-.387-.156.52.52 0 0 1-.159-.386V12.17q0-.285.193-.477a.65.65 0 0 1 .477-.193h2.788a.526.526 0 0 1 .542.537.53.53 0 0 1-.156.388.52.52 0 0 1-.386.158zM7.417 7.417V5.042a.526.526 0 0 1 .537-.542q.23 0 .387.156a.52.52 0 0 1 .159.386V7.83q0 .285-.193.477a.65.65 0 0 1-.477.193H5.042a.526.526 0 0 1-.542-.538q0-.227.156-.387a.52.52 0 0 1 .386-.158zm5.166 0h2.375a.526.526 0 0 1 .542.537.53.53 0 0 1-.156.387.52.52 0 0 1-.386.159H12.17a.65.65 0 0 1-.477-.193.65.65 0 0 1-.193-.477V5.042a.526.526 0 0 1 .537-.542q.23 0 .388.156a.52.52 0 0 1 .158.386z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullscreenExit);
export { ForwardRef as ReactComponent };